import { render, staticRenderFns } from "./my_invite_list.vue?vue&type=template&id=d223414a"
import script from "./my_invite_list.vue?vue&type=script&lang=js"
export * from "./my_invite_list.vue?vue&type=script&lang=js"
import style0 from "./my_invite_list.vue?vue&type=style&index=0&id=d223414a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports